import { render, staticRenderFns } from "./detectionOrder.vue?vue&type=template&id=fb39674c&scoped=true"
import script from "./detectionOrder.vue?vue&type=script&lang=js"
export * from "./detectionOrder.vue?vue&type=script&lang=js"
import style0 from "./detectionOrder.vue?vue&type=style&index=0&id=fb39674c&prod&lang=css"
import style1 from "./detectionOrder.vue?vue&type=style&index=1&id=fb39674c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb39674c",
  null
  
)

export default component.exports